// extracted by mini-css-extract-plugin
export default {"signupDetailsForm":"SignupDetailsForm_signupDetailsForm__a3kOL","row":"SignupDetailsForm_row__Qf8rE","sumbitButton":"SignupDetailsForm_sumbitButton__7nU3H"};